// Barrel re-export — all template code has moved to organized subfolders.
// This file preserves backward compatibility for existing imports.

export {
  // Shared types, constants, helpers, components
  type MenuTemplateProps,
  PAGE_BORDER,
  MENU_DESCRIPTION_DEFAULT,
  MENU_DESCRIPTION_MAX_WIDTH,
  CENTERED_MENU_DESCRIPTION_STYLE,
  LEFT_ALIGNED_MENU_DESCRIPTION_STYLE,
  ALACARTE_COLUMN_FLEX,
  ENTREE_CATS,
  BREAKFAST_MAIN_CATS,
  BREAKFAST_BEVERAGE_CATS,
  SECTION_LABEL,
  SECTION_ORDER,
  formatDisplayDate,
  extractAlwaysAvailableItems,
  cleanItems,
  groupByCategory,
  groupForMealDisplay,
  withMenuLogoCacheBust,
  MenuLogo,
  FitToPage,
} from './shared/menu-print-shared';

export { BreakfastTemplate } from './templates/breakfast-template';
export { MealTemplate } from './templates/meal-template';
export { AlaCarteTemplate, type AlaCarteTemplateProps } from './templates/alacarte-template';
